export const getUserRole = state => state.user.role.id || null;